import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from '../../theme/jss-types';
import { LeftOutlined, RightOutlined, VerticalRightOutlined } from '@ant-design/icons';

const styles = {
    main: {
        display: 'flex',
        alignItems: 'center',
        margin: '0px 8px',
    },
    pageNumber: {
        boxSizing: 'border-box',
        height: 22,
        width: 22,
        padding: '0px',
        border: '1px solid #999999',
        borderRadius: 3,
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
        textAlign: 'center',
        alignContent: 'center',
        backgroundColor: '#fafafa',
    },
    pageNumberText: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
    },
    left: {
        marginRight: 4,
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: 14,
    },
    right: {
        marginLeft: 4,
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: 14,
    },
};

interface PaginatorProps extends StylesProps<typeof styles> {
    isNextPresent: boolean;
    onNextClick: () => void;
    onPrevClick: () => void;
    onFirstClick?: () => void;
    currentPageNumber: number;
    hideFirstButton?: boolean;
    leftText?: string;
    rightText?: string;
    style?: React.CSSProperties;
    showPageNumberText?: boolean;
}

const Paginator = (props: PaginatorProps) => {
    const {
        classes,
        isNextPresent,
        onNextClick,
        onPrevClick,
        onFirstClick,
        currentPageNumber,
        hideFirstButton,
        leftText,
        rightText,
        style,
        showPageNumberText,
    } = props;

    const renderLeft = () => {
        return (
            <div onClick={currentPageNumber > 1 ? onPrevClick : undefined}>
                <LeftOutlined
                    className={classes.left}
                    disabled={currentPageNumber === 1}
                    style={{
                        color: currentPageNumber === 1 ? '#ddd' : '#000000',
                        cursor: currentPageNumber > 1 ? 'pointer' : 'default',
                    }}
                />
                <span style={{ opacity: currentPageNumber > 1 ? 1 : 0 }}>{leftText}</span>
            </div>
        );
    };

    const renderRight = () => {
        return (
            <div onClick={isNextPresent ? onNextClick : undefined}>
                <span style={{ opacity: isNextPresent ? 1 : 0 }}>{rightText}</span>
                <RightOutlined
                    className={classes.right}
                    disabled={!isNextPresent}
                    style={{
                        color: isNextPresent ? '#000000' : '#ddd',
                        cursor: isNextPresent ? 'pointer' : 'default',
                    }}
                />
            </div>
        );
    };

    const renderPageNumber = () => {
        if (showPageNumberText) {
            return (
                <div className={classes.pageNumberText}>
                    {`Page ${currentPageNumber}`}
                </div>
            );
        }
        return (
            <div className={classes.pageNumber}>
                {currentPageNumber}
            </div>
        );
    };

    const renderFirst = () => {
        return (
            <VerticalRightOutlined
                className={classes.left}
                onClick={currentPageNumber > 1 ? onFirstClick : undefined}
                style={{
                    color: currentPageNumber > 1 ? '#000000' : '#ddd',
                    cursor: currentPageNumber > 1 ? 'pointer' : 'default',
                }}
            />
        );
    };

    return (
        <div className={classes.main} style={{ ...style }}>
            {!hideFirstButton && renderFirst()}
            {renderLeft()}
            {renderPageNumber()}
            {renderRight()}
        </div>
    );
};

export default withStyles(styles)(Paginator);
